import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AnalyticsRoute = () => {
  const { role, user } = useAuth();

  if (role === 'SALON_MANAGER') return <Outlet />;

  if (role === 'SALON_STAFF' && user?.staffRegistrationRejected) {
    return <Navigate to="/staff/registration-rejected" replace />;
  }

  if (role === 'SALON_STAFF' && user?.staffPendingApproval) {
    return <Navigate to="/staff/pending-approval" replace />;
  }

  if (role === 'SALON_STAFF' && (user?.canViewAnalytics || user?.permissions?.canViewAnalytics)) {
    return <Outlet />;
  }

  return <Navigate to="/" replace />;
};

export default AnalyticsRoute;
